import React, { useState } from "react";
import Modal from "../../../Base/Modal";
import Amount from "../../../Base/Amount";
import DatePicker from "react-datepicker";

export default function CreateModal(props) {
  const [form, setForm] = useState({
    creationDate: "",
    expirationDate: "",
    amount: "",
    currency: "$",
    description: "",
  });
  const updateForm = (data) => {
    setForm((form) => ({ ...form, ...data }));
  };
  const onChangeInput = (input) => (e) => {
    setForm((form) => ({ ...form, [input]: e.target.value }));
  };
  console.log(form);
  return (
    <Modal close={props.close} title={props.title}>
      <div className="modal__invoice">
        <div className="input__outer">
          <label htmlFor="">Creation Date</label>
          <div className="input">
            <DatePicker
              onChange={(date) => updateForm({ creationDate: date })}
              placeholderText={"dd-mm-yyyy"}
              selected={form.creationDate}
              startDate={form.creationDate}
            />
          </div>
        </div>
        <div className="input__outer">
          <label htmlFor="">Expiration Date</label>
          <div className="input">
            <DatePicker
              onChange={(date) => updateForm({ expirationDate: date })}
              placeholderText={"dd-mm-yyyy"}
              selected={form.expirationDate}
              startDate={form.expirationDate}
            />
          </div>
        </div>
        <Amount
          onChangeInput={onChangeInput}
          form={form}
          updateForm={updateForm}
        />
        <div className="input__outer">
          <label htmlFor="">Description</label>
          <div className="input">
            <textarea
              name=""
              id=""
              cols="30"
              rows="3"
              value={form.description}
              onChange={onChangeInput("description")}
            ></textarea>
          </div>
        </div>
      </div>
      <div className="modal__inner-footer">
        <button type="button" className="button bordered" onClick={props.close}>
          Cancel
        </button>
        <button type="button" className="button primary" onClick={props.close}>
          Save
        </button>
      </div>
    </Modal>
  );
}
